/**
 * Non-production-only route gate for the internal API health page.
 */
const HEALTH_PAGE_ENVIRONMENTS = new Set(['development', 'staging', 'test']);

export function isHealthPageEnabled(environment = process.env.REACT_APP_ENVIRONMENT) {
  return HEALTH_PAGE_ENVIRONMENTS.has(String(environment || '').toLowerCase());
}
